import styled from '@emotion/styled';

export const SadaServiceSchedule = styled.div``;
